var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon",class:"icon-"+_vm.icon,domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon])}})
}
var staticRenderFns = []

export { render, staticRenderFns }